import React, {PureComponent} from 'react'
import {NavLink, withRouter} from 'react-router-dom'
import PropTypes from 'prop-types'
import Col from "../Col"
import Container from "../Container"
import BannerLogo from '../BannerLogo'
import Hamburger from '../Hamburger'
import ToggleOpen from '../../decorators/ToggleOpen'
import DropdownItem from '../DropdownItem/index'
import DropdownUser from '../DropdownUser/index'

import './TopMenu.sass'

export class TopMenu extends PureComponent {
  /* eslint-disable */
  static propTypes = {
    current_user: PropTypes.object,
    links: PropTypes.array.isRequired,
      path: PropTypes.string,
      name: PropTypes.string,
    registries: PropTypes.array,
    // listRoles: PropTypes.array,
    prefix: PropTypes.string.isRequired,
    suffix: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    toggleOpen: PropTypes.func.isRequired
  }

  render() {
    const { links,  prefix, suffix, toggleOpen, isOpen, current_user, listRoles, registries} = this.props
    return (
      <div className="nav-wrapper">
        <Container>
          <Col xs={6} sm={12} md={24} lg={24}>
            <ul className="nav-list">
              <li className="nav-list__item">
                <BannerLogo prefix={prefix} suffix={suffix} />
              </li>
              <ul className={`nav-list__items ${isOpen ? 'nav-list__items_active' : ''}`}>
                {links.map(link => {
                  return (
                    <li key={link.path} className="nav-list__item">
                      <NavLink activeClassName="nav-list__item_active" to={link.path}>{link.name}</NavLink>
                    </li>
                  )
                })}
                <DropdownItem title="Реестры" registries={registries} />
                {current_user.current_servant &&
                  <DropdownUser current_user={current_user} listRoles={listRoles}>
                    {`${current_user.current_servant.name} ${current_user.current_servant.surname}`}
                  </DropdownUser>
                }
              </ul>
              <Hamburger isOpen={isOpen} toggleOpen={toggleOpen} />
            </ul>
          </Col>
        </Container>
      </div>
    )
  }
}

export default withRouter(ToggleOpen(TopMenu))



// WEBPACK FOOTER //
// ./components/TopMenu/index.jsx